import { extend } from 'flarum/extend';
import HeaderPrimary from 'flarum/components/HeaderPrimary';

extend(HeaderPrimary.prototype, 'items', function(items) {
  items.add('forum-main-title', <h2 class="Header-title-custom">
                    <a href="/" id="home-link">
                      IT Base forum
                    </a>
                </h2>);
  items.add('itbase', <a href="https://itbase.ba"><i class="far fa-arrow-alt-circle-right"></i> IT Base portal</a>);
});
